<template>
  <main>
    <HeroSection />
    <AgentsSection />
    <WorkflowSection />
    <FeaturesSection />
    <VideoSection />
    <FooterBanner />
  </main>
</template>

<script>
import HeroSection from '@/components/HeroSection.vue'
import AgentsSection from '@/components/AgentsSection.vue'
import WorkflowSection from '@/components/WorkflowSection.vue'
import FeaturesSection from '@/components/FeaturesSection.vue'
import VideoSection from '@/components/VideoSection.vue'
import FooterBanner from '@/components/FooterBanner.vue'

export default {
  name: 'HomePage',
  components: { HeroSection, AgentsSection, WorkflowSection, FeaturesSection, VideoSection, FooterBanner }
}
</script>
